import script from "./ClientPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientPage.vue?vue&type=script&setup=true&lang=js"

import "./ClientPage.vue?vue&type=style&index=0&id=7a3b2112&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a3b2112"]])

export default __exports__